import { generatePath } from 'react-router';
import { paths } from '../../../common/constants/pathVariables.js';
import { mobiilivarmenneMsg, t } from '../../../common/i18n/index.js';
import { SearchResultRow } from '../SearchResultRow.js';
import { HeaderSectionContent, SectionContent } from '../SectionContent.js';

interface MobileCertificateProps {
  onSearchResultClick: () => void;
  setSearchFieldVisible: (visible: boolean) => void;
}

export const MobileCertificate = ({ onSearchResultClick, setSearchFieldVisible }: MobileCertificateProps) => {
  return (
    <SearchResultRow
      icon="mobiilivarmenne"
      upperSection={<HeaderSectionContent left={t.PKEZ(mobiilivarmenneMsg)} />}
      lowerSection={<SectionContent left={t.W585('Read more about Elisa Mobile Certificate')} />}
      linkHref={generatePath(paths.PS_MOBILE_CERTIFICATE)}
      onSearchResultClick={onSearchResultClick}
      setSearchFieldVisible={setSearchFieldVisible}
    />
  );
};
